<template lang="html">
    <div class="button-wrapper">
        <Button :title="label"  @click.native="handleAction()" />
    </div>

</template>

<script>
  import Button from '@/components/partials/Button'
  import actionHandler from '@/mixins/actionHandler.mixin'

  export default {
    components: {
      Button
    },
    mixins: [actionHandler],
    props: {
      label: {
        type: String,
        default: ''
      }
    },
    name: 'ActionButton'
  }
</script>

<style lang="scss" scoped>
 .button-wrapper {
     margin: $padding;
 }
</style>
